import React, { useState, useEffect } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { Card, CardContent, Typography } from '@material-ui/core';
import messages from 'containers/PreOpeningPage/messages';
import { translate } from 'containers/services/translate';
import { Container } from 'containers/PreOpeningPage/OpposingParty/styled-components';
import { CHOICE } from 'containers/PreOpeningPage/OpposingParty/constants';
import AddOpposingParty from 'containers/PreOpeningPage/OpposingParty/AddOpposingParty';
import { Listings } from 'containers/AppContainer/typings';
import OpposingPartyCheckbox from 'containers/PreOpeningPage/OpposingParty/OpposingPartyCheckbox';
import OpposingPartyRecap from 'containers/PreOpeningPage/OpposingParty/OpposingPartyRecap';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { Vehicule } from 'containers/PreOpeningPage/typings';

export interface OpposingPartyProps {
  intl: IntlShape;
  listings: Listings;
  claimToPreopen: any;
  setClaimToPreopen: React.Dispatch<React.SetStateAction<any>>;
  opposingPartyValidation: any;
  shouldDisplayAllClaimInfo?: boolean;
  sagisOpposingParties: any;
  isConversion?: boolean;
  isCourtManagerBasicManagement?: boolean;
  location?: any;
}

const OpposingParty: React.FC<OpposingPartyProps> = ({
  listings,
  claimToPreopen,
  setClaimToPreopen,
  opposingPartyValidation,
  ...props
}): JSX.Element => {
  const [hasMaterialDammage, setHasMaterialDammage] = useState<string | null>(
    null,
  );

  const [expandedOpposingRecap, setExpandedOpposingRecap] = React.useState<
    boolean[]
  >([]);
  const [toggleOpen, setToggleOpen] = React.useState<boolean>(false);
  const [renderSubForm, setRenderSubForm] = React.useState<boolean>(true);
  const addOpposingPartyHandler = () => {
    setToggleOpen(false);
    setRenderSubForm(false);
  };

  useEffect(() => {
    if (claimToPreopen.opposingParty.hasMaterialDammage) {
      setHasMaterialDammage(claimToPreopen.opposingParty.hasMaterialDammage);
    }
  }, [claimToPreopen.opposingParty.hasMaterialDammage]);

  const shouldDisplayAddButton = (
    hasMaterialDammage: string | null,
    length: number,
  ) => hasMaterialDammage === CHOICE.YES && length > 0;
  return (
    <Container className="container">
      <Card>
        <CardContent>
          <Typography className="title">
            {translate({ ...messages.opposingPartyCardTitle }, props)}
          </Typography>
          {shouldDisplayAddButton(
            hasMaterialDammage,
            claimToPreopen.opposingParty.vehicules.length,
          ) &&
            !props.isCourtManagerBasicManagement &&
            !props.isConversion &&
            !props.shouldDisplayAllClaimInfo && (
              <div className="add-opposingParty-container">
                <div className="add-opposingParty">
                  <PrimaryButton
                    title={translate({ ...messages.addOpposingParty }, props)}
                    lefticon={
                      <AddCircleOutlineIcon className="icon" fontSize="small" />
                    }
                    onClick={addOpposingPartyHandler}
                  />
                </div>
              </div>
            )}
          {!props.shouldDisplayAllClaimInfo &&
            !props.isCourtManagerBasicManagement && (
              <OpposingPartyCheckbox
                hasMaterialDammage={hasMaterialDammage}
                setHasMaterialDammage={setHasMaterialDammage}
                claimToPreopen={claimToPreopen}
                setClaimToPreopen={setClaimToPreopen}
                opposingPartyValidation={opposingPartyValidation}
              />
            )}
          {hasMaterialDammage === CHOICE.YES && (
            <>
              {claimToPreopen.opposingParty.vehicules.map(
                (el: Vehicule, index: number) => (
                  <OpposingPartyRecap
                    listings={listings}
                    vehicule={el}
                    index={index}
                    claimToPreopen={claimToPreopen}
                    setClaimToPreopen={setClaimToPreopen}
                    expanded={expandedOpposingRecap}
                    setExpanded={setExpandedOpposingRecap}
                    setRenderForm={setRenderSubForm}
                    setToggleOpen={setToggleOpen}
                    isForDrawer={false}
                    isFromSagis={el.isFromSagis}
                    sagisOpposingParties={props.sagisOpposingParties}
                  />
                ),
              )}
              {!toggleOpen &&
                !props.shouldDisplayAllClaimInfo &&
                !props.isCourtManagerBasicManagement && (
                  <AddOpposingParty
                    listings={listings}
                    claimToPreopen={claimToPreopen}
                    setClaimToPreopen={setClaimToPreopen}
                    toggleOpen={toggleOpen}
                    setToggleOpen={setToggleOpen}
                    renderSubForm={renderSubForm}
                    isForDrawer={false}
                  />
                )}
            </>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};
export default injectIntl(OpposingParty);
